/** D8 天染:sky 组;把天空拉向目标色相(饱和度钳制≤55%),10s入/15s回。 */
import { BaseEffect, EffectGroup } from './base';
import { sky } from '../engine/SkyRenderer';
import { scene } from '../engine/Scene';
import { hslToRgb, darken, lighten } from '../engine/Palette';
import { rand } from '../engine/util';

export class SkyColorEffect extends BaseEffect {
  id = 'sky_color';
  exclusiveGroup: EffectGroup = 'sky';
  private cleared = false;

  onStart(meta?: any) {
    this.tail = 15;
    const hue = meta?.hue ?? rand(0, 360);
    const mid = hslToRgb(hue, 0.5, 0.52);   // 饱和度钳制 ≤ 0.55
    sky.overrideTo({ mid, top: darken(mid, 0.4), bottom: lighten(mid, 0.25), ambient: 0.42 }, 10);
    scene.crowd?.broadcast('idle', 3);
  }
  onUpdate() {
    if (this.t > this.dur && !this.cleared) { this.cleared = true; sky.clearOverride(15); }
  }
  onResolve() { if (!this.cleared) { this.cleared = true; sky.clearOverride(8); } }
  onDestroy() { sky.clearOverride(6); }
}
